module.exports = __webpack_public_path__ + "img/focaccia_roasted.9471e6d4.jpg";